import { Link } from '../lib/router'

export function CookiesPage() {
  return (
    <main className="section page pb-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <header className="mb-12">
          <p className="eyebrow text-magma">Trasparenza e Sicurezza</p>
          <h1 className="text-4xl md:text-5xl font-display uppercase tracking-wider mb-4 text-white">Cookie Policy</h1>
          <p className="text-neutral-400 text-sm">Ultimo aggiornamento: 28 Luglio 2026</p>
        </header>

        <div className="space-y-8 text-neutral-300 leading-relaxed">
          <section>
            <p className="text-lg">
              La presente Cookie Policy ha lo scopo di illustrare all'utente le modalità e le finalità dell'utilizzo dei cookie sul sito web <strong>blastcore.it</strong>.
            </p>
          </section>

          <section className="bg-green-950/30 border border-green-500/30 p-6 rounded-lg relative overflow-hidden">
            <div className="absolute top-0 left-0 w-1 h-full bg-green-500"></div>
            <h2 className="text-2xl font-display text-white mb-2 uppercase tracking-wide">Zero Cookie, Zero Tracciamenti</h2>
            <p className="text-green-200/90 text-lg">
              Il sito web BlastCore è stato progettato ponendo al primo posto la privacy degli utenti. Siamo orgogliosi di confermare che <strong>questo sito non utilizza alcun tipo di cookie, né strumenti di tracciamento equivalenti (come LocalStorage o SessionStorage), né propri né di terze parti</strong>, per analizzare il comportamento degli utenti o per finalità pubblicitarie.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-display text-white mb-4 uppercase tracking-wide mt-12">Assenza di Cookie Banner</h2>
            <div className="bg-obsidian border border-neutral-800 p-6 rounded-md text-neutral-400">
              <p>
                In conformità con le Linee Guida del Garante per la Protezione dei Dati Personali e con la Direttiva ePrivacy, poiché il nostro sito non installa alcun cookie (nemmeno tecnico, in quanto non è prevista l'autenticazione web) o analytics di terze parti, <strong>non siamo tenuti a mostrare alcun banner per la raccolta del consenso</strong>.
              </p>
              <p className="mt-3">
                La tua navigazione sul nostro sito è completamente anonima e libera da tracciamenti pubblicitari, profilazioni e pop-up intrusivi.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-display text-white mb-4 uppercase tracking-wide mt-12">Risorse Esterne (Immagini)</h2>
            <p className="mb-4">
              Per poter mostrare l'aspetto visivo dei giocatori (avatar e modelli dei personaggi di Minecraft) sulle nostre classifiche e sui profili pubblici, il sito effettua richieste dirette al servizio di fornitura immagini <strong>MCHeads</strong> (mc-heads.net).
            </p>
            <div className="bg-obsidian border border-neutral-800 p-5 rounded-md text-neutral-400 border-l-4 border-l-magma">
              <p>
                Sebbene questo non comporti l'installazione di cookie sul tuo dispositivo da parte del nostro sito o di MCHeads, il tuo browser per motivi puramente tecnici trasmetterà il tuo indirizzo IP e il tuo User-Agent a MCHeads per poter scaricare l'immagine. 
              </p>
            </div>
            <p className="mt-6 text-sm text-neutral-500">
              Per maggiori dettagli su come gestiamo l'infrastruttura e i dati, ti invitiamo a consultare la nostra <Link to="/privacy" className="text-magma hover:text-ember underline underline-offset-4">Privacy Policy</Link>.
            </p>
          </section>
        </div>
      </div>
    </main>
  )
}
